export default {
  text: [
    'After two years of being the leading video shopping app, MikMak understands the pain points brands face in trying to create, scale and measure video commerce.',
    'MikMak’s Platform is designed to connect brands to today’s video shoppers.'
  ]
}



// WEBPACK FOOTER //
// ./client/store/imports/IntroText.js